export default "__VITE_ASSET__BQGVkWNP__"